<template>
  <div>
    <div>
      <ul class="nav nav-tabs">
        <li
          v-for="product in sortedProducts"
          :key="product.id"
          class="nav-item"
          :class="'link-' + product.name"
        >
          <a
            :href="'#' + getProductName(product.id).replace(/\s/g, '')"
            data-toggle="tab"
            :class="{ active: currentTabId === product.id }"
            :data-test="'patient-product-tab-' + product.name.toLowerCase()"
            aria-expanded="false"
            class="nav-link"
            @click="setCurrentTab(product)"
          >
            <span>{{ product.display_name }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div
        v-for="product in sortedProducts"
        :id="getProductName(product.id).replace(/\s/g, '')"
        :key="product.id"
        class="tab-pane"
        :class="{ active: currentTabId === product.id }"
      >
        <wound v-if="product.id === 2" :patient="dataPatient"></wound>
        <patient-product
          v-else-if="dataPatient && patientProducts.includes(product.id)"
          :ref="`patientProduct${product.id}`"
          :patient="dataPatient"
          :product="product"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Mole from "./Products/Mole.vue";
import Wound from "./Products/Wound/Wound.vue";
import Photo from "./Products/Photo.vue";
import PatientProduct from "./Products/PatientProduct.vue";
import {
  getGenericPatientProductTypes,
  getProductNameByType,
} from "../../helpers/product";
export default {
  components: {
    Mole,
    Wound,
    Photo,
    PatientProduct,
  },
  props: {
    dataPatient: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      products: [],
      chatNotifications: null,
      patientProducts: getGenericPatientProductTypes(),
      currentTabId: null,
    };
  },
  computed: {
    sortedProducts() {
      return this.products.sort((a, b) => {
        const textA = a.name?.toUpperCase() || "";
        const textB = b.name?.toUpperCase() || "";
        return textA > textB ? -1 : textA < textB ? 1 : 0;
      });
    },
  },
  watch: {
    dataPatient: {
      handler() {
        if (this.dataPatient && this.sortedProducts.length > 0) {
          this.$nextTick(() => {
            this.setCurrentTab(this.sortedProducts[0]);
          });
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    this.setProducts();
  },
  mounted() {
    this.setCurrentTab(this.sortedProducts[0]);
  },
  methods: {
    setCurrentTab(product) {
      if (product && this.patientProducts.includes(product.id)) {
        this.currentTabId = product.id;
        const ref = `patientProduct${product.id}`;
        if (this.$refs[ref]?.[0]) {
          this.$refs[ref][0].loadData();
        }
        this.$store.commit(
          "setShowPatientChatContainer",
          product.isPatientFocused,
        );
      }
    },
    setProducts() {
      const products = [];
      for (const productKey in this.$store.state.user.products) {
        let product = this.$store.state.user.products[productKey];
        if (this.dataPatient.productIds.includes(product.id)) {
          products.push(product);
        }
      }
      this.products = products;
    },
    getProductName(id) {
      return getProductNameByType(id);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "/resources/assets/sass/abstracts/variables";

.nav.nav-tabs a.nav-link.active {
  color: variables.$dermicusBlue !important;
}
</style>
